import { render, staticRenderFns } from "./HotUser.vue?vue&type=template&id=1f1f7660&"
import script from "./HotUser.vue?vue&type=script&lang=js&"
export * from "./HotUser.vue?vue&type=script&lang=js&"
import style0 from "./HotUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports